import { Card, Tag, Typography } from 'antd';
import { space } from '@viq-admin/ui';
import type { CaptureType, LiveFeedCapture } from './types';

const TYPE_COLOR: Record<CaptureType, string> = {
  voice: 'purple',
  badge: 'blue',
  card: 'green',
};

export function CaptureCard({
  capture,
  onOpen,
}: {
  capture: LiveFeedCapture;
  onOpen?: (id: string) => void;
}) {
  const time = new Date(capture.createdAt).toLocaleTimeString();
  const meta = [capture.title, capture.companyName].filter(Boolean).join(' · ');
  const open = () => onOpen?.(capture.id);
  return (
    <Card
      size="small"
      hoverable
      role="button"
      tabIndex={0}
      onClick={open}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      }}
      style={{ marginBottom: space.sm, cursor: 'pointer' }}
    >
      <div style={{ display: 'flex', alignItems: 'baseline', gap: space.md }}>
        <Tag color={TYPE_COLOR[capture.captureType]}>{capture.captureType}</Tag>
        <Typography.Text type="secondary" style={{ fontVariant: 'tabular-nums' }}>
          {time}
        </Typography.Text>
        <Typography.Text style={{ flex: 1 }} ellipsis>
          {capture.preview}
        </Typography.Text>
      </div>
      {meta && (
        <Typography.Text
          type="secondary"
          data-testid="capture-meta"
          ellipsis
          style={{ display: 'block', marginTop: 2 }}
        >
          {meta}
        </Typography.Text>
      )}
    </Card>
  );
}
